<template>
  <div id="goods-list" class="carrier-list-data">
    <div class="summary din" @click="$emit('close')">
      <div class="date">{{ formatDate(liveStreamLog[0].date.toString()) }}</div>
      <div>当日累计上架商品 {{ tableData.length }}个，销量为 {{ $retainWan(totalVolume) }}，销售额为 ¥{{ $retainWan(totalSales) }}</div>
      <van-icon class="close-btn" name="cross" />
    </div>
    <router-link
      :to="`/goods/${item.itemId}`"
      v-for="(item, index) in tableData"
      :key="item.itemId"
      class="item-default"
    >
      <div class="commodity-sort">{{ index + 1 }}</div>
      <div class="item-icon">
        <img :src="$changeCDN(item.platformImageUrl)" alt="商品" />
      </div>
      <div class="center-anchor-goods">
        <div class="item-name">{{ item.commodity }}</div>
        <div class="align item-source">
          <div class="item-source-icon" :style="returnPosition(item)"></div>
          <div class="item-goods-price">¥{{ Number(item.price).toFixed(2) }}</div>
        </div>
      </div>
      <object class="flex-all">
        <a href="javascript:void(0)">
          <div class="data-for-detail">
            <div class="data-title">销售额</div>
            <div class="data-number data-number-red">
              {{ Number(item.totalVolumes) && Number(item.price) && !Number(item.totalSales) ? '未列入统计' :  String(item.totalSales) ? '¥' + $retainWan(item.totalSales) : '-' }}
            </div>
            <div class="data-title data-title-sec">销量</div>
            <div class="data-number">{{ $retainWan(item.totalVolumes) }}</div>
          </div>
        </a>
      </object>
    </router-link>
    <footer>已显示当日上架所有商品</footer>
  </div>
</template>

<script>
export default {
  props: { liveStreamLog: Array },
  data() {
    return {
      tableData: [],
      totalSales: 0,
      totalVolume: 0
    }
  },
  watch: {
    liveStreamLog: {
      handler(val) {
        if (!this.$store.state.userLevel || this.$store.state.userLevel > 100) {
          return
        }
        const liveIdArr = []
        for (const live of val) {
          liveIdArr.push(live.id)
        }
        this.$showLoading()
        this.$get({
          road: 'liveStreamsSales',
          data: { road: 'gifshow', anchorId: this.$route.params.id },
          params: { liveStreamLogIds: JSON.stringify(liveIdArr) },
          version: 'v2'
        }).then(res => {
          this.tableData = res
          let sales = 0
          let volume = 0
          for (const goods of res) {
            sales += Number(goods.totalSales)
            volume += Number(goods.totalVolumes)
          }
          this.totalSales = sales
          this.totalVolume = volume
        }).finally(() => {
          this.$hideLoading()
        })
      },
      immediate: true
    }
  },
  methods: {
    formatDate(date, template = 'YYYY-MM-DD') {
      return moment(date).format(template)
    },
    returnPosition(val) {
      const platform = this.$store.state.sourceIconPosition[val.sourceType] || {}
      const position = platform.position || 0
      return `background-position: ${position}rem 0`
    }
  }
}
</script>

<style lang="less" scoped>
@import "./common.less";
</style>